import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as BackupSettingsActions from '../actions/backup-settings.action';
import { filter, map, mergeMap } from 'rxjs/operators';
import { HostingService } from '../../websites/website/hosting/hosting.service';
import { DbResponse } from '../../shared/interceptors/db-response';

@Injectable()
export class BackupSettingsEffect {
  loadBackupSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BackupSettingsActions.LOAD_BACKUP_SETTINGS),
      mergeMap((action: BackupSettingsActions.LoadBackupSettings) => {
        const websiteId = action.payload;
        return this._hostingService.getBackupSettings(websiteId).pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new BackupSettingsActions.LoadBackupSettingsSuccess({
                websiteId,
                entities: response.data,
              });
            }
          }),
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private _hostingService: HostingService
  ) {}
}
